import React from 'react';
import Icon from '../../../components/AppIcon';

const ContactStats = ({ 
  stats = {},
  className = '' 
}) => {
  const defaultStats = {
    totalContacts: 0,
    contactsThisWeek: 0,
    averageResponseTime: 0,
    longestGap: 0,
    ...stats
  };

  const statItems = [
    {
      label: 'Total Contacts',
      value: defaultStats?.totalContacts,
      icon: 'Users',
      color: 'bg-primary',
      change: '+12 this month'
    },
    {
      label: 'Contacted This Week',
      value: defaultStats?.contactsThisWeek,
      icon: 'MessageSquare',
      color: 'bg-success',
      change: '+3 from last week'
    },
    {
      label: 'Avg Response Time',
      value: `${defaultStats?.averageResponseTime}h`,
      icon: 'Clock',
      color: 'bg-warning',
      change: '2h faster'
    },
    {
      label: 'Longest Gap',
      value: `${defaultStats?.longestGap}d`,
      icon: 'Calendar',
      color: 'bg-error',
      change: 'Improving'
    }
  ];

  return (
    <div className={`bg-surface border border-border rounded-xl p-6 shadow-card ${className}`}>
      {/* Header */}
      <div className="flex items-center space-x-3 mb-6">
        <div className="w-10 h-10 bg-accent rounded-lg flex items-center justify-center">
          <Icon name="BarChart3" size={20} color="white" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-text-primary">
            Relationship Stats
          </h3>
          <p className="text-sm text-text-secondary">
            Your networking performance
          </p>
        </div>
      </div>
      {/* Stats Grid */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {statItems?.map((item, index) => (
          <div key={index} className="text-center">
            <div className={`w-12 h-12 ${item?.color} rounded-lg flex items-center justify-center mx-auto mb-3`}>
              <Icon name={item?.icon} size={20} color="white" />
            </div>
            
            <div className="text-2xl font-bold text-text-primary mb-1">
              {item?.value}
            </div>
            
            <div className="text-sm font-medium text-text-primary mb-1">
              {item?.label}
            </div>
            
            <div className="text-xs text-success">
              {item?.change}
            </div>
          </div>
        ))}
      </div>
      {/* Progress Indicators */}
      <div className="mt-6 pt-6 border-t border-border">
        <div className="space-y-4">
          <div>
            <div className="flex justify-between items-center mb-2">
              <span className="text-sm font-medium text-text-primary">Weekly Goal</span>
              <span className="text-sm text-text-secondary">
                {defaultStats?.contactsThisWeek}/10
              </span>
            </div>
            <div className="w-full bg-muted rounded-full h-2">
              <div 
                className="bg-primary h-2 rounded-full transition-all duration-300"
                style={{ width: `${Math.min((defaultStats?.contactsThisWeek / 10) * 100, 100)}%` }}
              ></div>
            </div>
          </div>

          <div>
            <div className="flex justify-between items-center mb-2">
              <span className="text-sm font-medium text-text-primary">Response Rate</span>
              <span className="text-sm text-text-secondary">85%</span>
            </div>
            <div className="w-full bg-muted rounded-full h-2">
              <div 
                className="bg-success h-2 rounded-full transition-all duration-300"
                style={{ width: '85%' }}
              ></div>
            </div>
          </div>
        </div>
      </div>
      {/* Quick Insights */}
      <div className="mt-6 pt-6 border-t border-border">
        <h4 className="font-medium text-text-primary mb-3">Quick Insights</h4>
        <div className="space-y-2">
          <div className="flex items-center space-x-2 text-sm">
            <Icon name="TrendingUp" size={14} className="text-success" />
            <span className="text-text-secondary">
              Your contact frequency has improved by 25% this month
            </span>
          </div>
          <div className="flex items-center space-x-2 text-sm">
            <Icon name="Target" size={14} className="text-primary" />
            <span className="text-text-secondary">
              You're on track to meet your monthly networking goal
            </span>
          </div>
          <div className="flex items-center space-x-2 text-sm">
            <Icon name="AlertCircle" size={14} className="text-warning" />
            <span className="text-text-secondary">
              5 contacts haven't been reached in over 3 months
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactStats;